export default import.meta.ROLLDOWN_FILE_URL_nfSYHBnrEfg1A82Bgp7Mrg